<script setup>
import { defineModel, reactive, defineExpose } from 'vue'

const formData = defineModel()

const errors = reactive({
    name: '',
    email: ''
})

const touched = reactive({
    name: false,
    email: false
})

const validateName = () => {
    if (!formData.value.name || formData.value.name.trim() === '') {
        errors.name = 'Имя и фамилия обязательны для заполнения'
        return false
    }
    if (formData.value.name.trim().length < 2) {
        errors.name = 'Имя должно содержать минимум 2 символа'
        return false
    }
    errors.name = ''
    return true
}

const validateEmail = () => {
    if (!formData.value.email || formData.value.email.trim() === '') {
        errors.email = 'Email обязателен для заполнения'
        return false
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(formData.value.email)) {
        errors.email = 'Введите корректный email адрес'
        return false
    }
    errors.email = ''
    return true
}

const validate = () => {
    touched.name = true
    touched.email = true

    const isNameValid = validateName()
    const isEmailValid = validateEmail()

    return isNameValid && isEmailValid
}

const resetValidation = () => {
    errors.name = ''
    errors.email = ''
    touched.name = false
    touched.email = false
}

const handleNameInput = () => {
    touched.name = true
    validateName()
}

const handleEmailInput = () => {
    touched.email = true
    validateEmail()
}

// Экспортируем методы для родительского компонента
defineExpose({
    validate,
    resetValidation
})
</script>

<template>
    <div class="w-full flex flex-col items-center justify-center">
        <div class="w-full bg-white p-4 lg:p-[25px] border border-[#e1e1e1] rounded-[16px]">
            <div class="font-bold text-[18px] lg:text-[20px] mb-4 lg:mb-[32px]">Контактные данные</div>
            <div class="w-full flex flex-col gap-4">
                <div>
                    <div>
                        <label class="block text-sm font-semibold text-gray-700 mb-2">
                            Имя и фамилия <span class="text-red-500">*</span>
                        </label>
                        <input
                            v-model="formData.name"
                            type="text"
                            placeholder="Иван Иванов"
                            @input="handleNameInput"
                            :class="[
                                'w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 transition duration-200',
                                touched.name && errors.name
                                    ? 'border-red-500 focus:ring-red-500'
                                    : 'border-gray-300 focus:ring-blue-500 focus:border-transparent'
                            ]"
                        />
                        <p v-if="touched.name && errors.name" class="mt-1 text-sm text-red-500">
                            {{ errors.name }}
                        </p>
                    </div>
                </div>
                <div>
                    <div>
                        <label class="block text-sm font-semibold text-gray-700 mb-2">
                            Email <span class="text-red-500">*</span>
                        </label>
                        <input
                            v-model="formData.email"
                            type="text"
                            placeholder="Ivan@company.ru"
                            @input="handleEmailInput"
                            :class="[
                                'w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 transition duration-200',
                                touched.email && errors.email
                                    ? 'border-red-500 focus:ring-red-500'
                                    : 'border-gray-300 focus:ring-blue-500 focus:border-transparent'
                            ]"
                        />
                        <p v-if="touched.email && errors.email" class="mt-1 text-sm text-red-500">
                            {{ errors.email }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
